module.exports = __webpack_public_path__ + "static/knitrabbit-bf93801f9541a082298de5d020416b28.jpeg";